import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { ListaReposicaoItemDBService } from '../database/lista-reposicao-item-db.service';

@Injectable({providedIn: 'root'})
export class ListaReposicaoItemService extends BaseService {
    override classname = 'ListaReposicaoItemService';
    override route = 'lista-reposicao-item';
    override database = new ListaReposicaoItemDBService();
}
